
// let phoneNumber = ''
// let isOtpSent = false
// let manualMode = false // false = aggregator/autofill mode, true = manual typing mode
// let completedOnce = false // tracks if OTP was already filled once

// document.addEventListener('DOMContentLoaded', () => {
//   try {
//     // --- setup ---
//     // Cache DOM refs
//     const loginTogglerButtons = document.querySelectorAll('.login_form_toggler_button')
//     const togglerWrap = document.querySelector('.login_form_toggler')
//     const sendOtpButton = document.getElementById('sendOtp')
//     const verifyOtpButton = document.getElementById('verifyOtp')
//     const isLoginPage = document.body.classList.contains('template-customers-login')

//     const emailLoginCont = document.querySelector('.email_login_cont')
//     const otpLoginCont = document.querySelector('.otp_login_cont')
//     const emailRegisterCont = document.querySelector('.email_register_cont')
//     const otpRegisterCont = document.querySelector('.otp_register_cont')

//     const otpCont = document.querySelector('.otp_cont')
//     const phoneInput = document.getElementById('CustomerPhone')
//     const otpInputs = document.querySelectorAll('.otp_input')
//     const otpInputContainer = document.querySelector('.otp_input_cont')
//     const statusMessageParent = document.getElementById('statusMessageParent')
//     const OTP_LENGTH = otpInputs.length

//     // helpers that DO NOT change your show/hide logic
//     const setDisplay = (el, v) => { if (el) el.style.display = v }
//     const enableContainer = (container, isEnabled) => {
//       if (!container) return
//       container.querySelectorAll('input').forEach((input) => { input.disabled = !isEnabled })
//     }

//     // Network helper: try with credentials first, fall back to omit if browser blocks
//     const postJson = async (url, payload, options = {}) => {
//       const { withCredentials = true } = options
//       const base = {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify(payload),
//         cache: 'no-store',
//         keepalive: true,
//       }
//       try {
//         return await fetch(url, { ...base, credentials: withCredentials ? 'include' : 'omit' })
//       } catch (err) {
//         if (!withCredentials) throw err
//         return fetch(url, { ...base, credentials: 'omit' })
//       }
//     }

//     // --- Hidden aggregator (unchanged behavior) ---
//     const agg = document.createElement('input')
//     agg.type = 'tel'
//     agg.inputMode = 'numeric'
//     agg.autocomplete = 'one-time-code'
//     agg.id = 'otp_agg'
//     agg.setAttribute('aria-hidden', 'true')
//     agg.tabIndex = -1
//     Object.assign(agg.style, {
//       position: 'absolute',
//       left: '-9999px',
//       top: '0',
//       width: '1px',
//       height: '1px',
//       opacity: '0',
//       pointerEvents: 'none'
//     })
//     if (otpInputContainer && otpInputContainer.parentElement) {
//       otpInputContainer.parentElement.appendChild(agg)
//     }

//     // --- Centralized verifier (same API / flow) ---
//     async function verifyOtp(otp) {
//       if (!otp) {
//         showStatus('გთხოვთ შეიყვანოთ კოდი', true)
//         return
//       }
//       if (verifyOtpButton) verifyOtpButton.disabled = true
//       try {
//         const response = await postJson(
//           'https://otp-auth.meama.ge/api/auth/verify-otp',
//           { phoneNumber, otp }
//         )
//         const data = await response.json()
//         if (data.success) {
//           showStatus('წარმატებით შეხვედით', false)
//           if (data.redirectUrl) window.location.href = data.redirectUrl
//         } else {
//           showStatus(data.message || 'არასწორი კოდი', true)
//           if (data.redirectUrl) window.location.href = data.redirectUrl
//           if (data.remainingAttempts) {
//             showStatus(`დარჩენილი მცდელობების რაოდენობა: ${data.remainingAttempts}`, true)
//           }
//         }
//       } catch (error) {
//         showStatus('სერვერთან დაკავშირება ვერ მოხერხდა', true)
//         console.error('Error:', error)
//       } finally {
//         if (verifyOtpButton) verifyOtpButton.disabled = false
//       }
//     }

// function fillFromCode(code) {
//   const digits = (code || '').replace(/\D/g, '').slice(0, OTP_LENGTH).split('');

//   otpInputs.forEach((box, i) => { box.value = digits[i] || '' });

//   updateVerifyButtonState();

//   // If full OTP pasted/autofilled
//   if (digits.length === OTP_LENGTH) {
//     completedOnce = true;

//     // LOCK USER INPUT & DISABLE BUTTON for the full 3.5s
//     manualMode = false;  // block typing
//     if (verifyOtpButton) verifyOtpButton.disabled = true;

//     // Add a visual disabled state (optional)
//     verifyOtpButton?.classList.add('locked');

//     // unlock AFTER the timeout + automatically verify
//     setTimeout(() => {
//       verifyOtpButton?.classList.remove('locked');
//       // still keep it disabled (your flow auto-verifies)
//       verifyOtpButton.disabled = true;

//       verifyOtp(digits.join(''));
//     }, 3500);
//   }
// }

//     // --- EXACT same toggler show/hide structure ---
//     loginTogglerButtons.forEach((button, index) => {
//       button.addEventListener('click', () => {
//         loginTogglerButtons.forEach((btn) => btn.classList.remove('active'))

//         if (index === 1) {
//           togglerWrap && togglerWrap.classList.add('switched')
//           if (isLoginPage) {
//             setDisplay(emailLoginCont, 'flex')
//             setDisplay(otpLoginCont, 'none')
//             enableContainer(emailLoginCont, true)
//             enableContainer(otpLoginCont, false)
//           } else {
//             setDisplay(emailRegisterCont, 'flex')
//             setDisplay(otpRegisterCont, 'none')
//             enableContainer(emailRegisterCont, true)
//             enableContainer(otpRegisterCont, false)
//           }
//         } else {
//           togglerWrap && togglerWrap.classList.remove('switched')
//           if (isLoginPage) {
//             setDisplay(emailLoginCont, 'none')
//             setDisplay(otpLoginCont, 'flex')
//             enableContainer(emailLoginCont, false)
//             enableContainer(otpLoginCont, true)
//           } else {
//             setDisplay(emailRegisterCont, 'none')
//             setDisplay(otpRegisterCont, 'grid') // IMPORTANT: keep grid
//             enableContainer(emailRegisterCont, false)
//             enableContainer(otpRegisterCont, true)
//           }
//         }
//         button.classList.add('active')
//       })
//     })

//     // --- Status box + styles (same visuals) ---
//     const statusMessageBox = document.createElement('div')
//     statusMessageBox.classList.add('status-message')
//     if (statusMessageParent) statusMessageParent.insertAdjacentElement('afterend', statusMessageBox)

//     if (otpCont) setDisplay(otpCont, 'none') // keep initial hidden

//     const style = document.createElement('style')
//     style.textContent = `
//       #CustomerPhone.invalid { border-color: #f44336 !important; border-width: 2px !important; }
//       #sendOtp, #verifyOtp { transition: opacity 0.3s ease, filter 0.3s ease; }
//       /* keep disabled state lightly visible */
//       #sendOtp:disabled, #verifyOtp:disabled { opacity: 0.88; filter: none; cursor: not-allowed; }
//       /* explicit grey when lock state is applied */
//       #verifyOtp.locked, #verifyOtp:disabled.locked { opacity: 0.5; filter: grayscale(0.85); }
//       .status-message {
//         padding: 10px; border-radius: 4px; margin-top: 10px;
//         display: none; text-align: center; width: 100%;
//         font-size: 14px; line-height: 1.4;
//       }
//       .status-message.error { background-color: #ffebee; color: #c62828; border: 1px solid #ef9a9a; }
//       .status-message.success { background-color: #e8f5e9; color: #2e7d32; border: 1px solid #a5d6a7; }
//     `
//     document.head.appendChild(style)

//     const ALLOWED_PHONE_CODES = [
//       '995','49','33','39','34','1','44','48','90','994','374','7','380','375','998','992','996','86','81','82'
//     ]
//     const startsWithAllowedCode = (cleaned) => ALLOWED_PHONE_CODES.some((code) => cleaned.startsWith(code))
//     const isGeorgianLocal = (number) => /^5\d{8}$/.test(number)
//     const isValidPhoneNumber = (input) => {
//       const cleaned = input.replace(/\D/g, '')
//       if (isGeorgianLocal(cleaned)) return true
//       return startsWithAllowedCode(cleaned) && cleaned.length >= 8
//     }
//     const formatPhoneNumber = (number) => {
//       const cleaned = number.replace(/\D/g, '')
//       if (isGeorgianLocal(cleaned)) return '995' + cleaned
//       return cleaned
//     }

//     phoneInput?.addEventListener('input', (e) => {
//       const isValid = isValidPhoneNumber(e.target.value)
//       e.target.classList.toggle('invalid', !isValid)
//     }, { passive: true })

//     if (verifyOtpButton) verifyOtpButton.style.display = 'none'

//     function updateVerifyButtonState() {
//       const anyFilled = Array.from(otpInputs).some((input) => input.value.length === 1)
      
//       if (verifyOtpButton) {
//         // Enable button when nothing is entered (lightened up)
//         // Disable button when any digit is entered (gray/locked)
//         verifyOtpButton.disabled = anyFilled
//       }
//     }

//     // Restore OTP from storage
//     const storedOtp = localStorage.getItem('lastOtp')
//     if (storedOtp) {
//       fillFromCode(storedOtp)
//       localStorage.removeItem('lastOtp')
//     }

//     // Aggregator input
//     agg.addEventListener('input', () => {
//       if (manualMode) return // ignore autofill while in manual mode
//       if (!agg.value) return
//       fillFromCode(agg.value)
//     })

//     // Container paste
//     otpInputContainer?.addEventListener('paste', (e) => {
//       e.preventDefault()
//       const text = (e.clipboardData || window.clipboardData)?.getData('text') || ''
//       if (text) {
//         manualMode = false
//         agg.value = text
//         fillFromCode(text)
//       }
//     })

//     // --- Visible OTP boxes with pointer-based tap detection (unchanged) ---
//     otpInputs.forEach((input, index) => {
//       input.setAttribute('maxlength', '1')
//       input.setAttribute('name', `otp_${index + 1}`)

//       let lastTapTime = 0

//       input.addEventListener('pointerdown', () => {
//         const now = Date.now()
//         const doubleTap = now - lastTapTime < 300
//         lastTapTime = now
//         input.dataset.tapType = doubleTap ? 'double' : 'single'
//       })

//       input.addEventListener('focus', (e) => {
//         const tapType = input.dataset.tapType
//         delete input.dataset.tapType

//         if (tapType === 'double') {
//           manualMode = true // sticky manual
//           input.focus()
//           input.select()
//           return
//         }

//         if (tapType === 'single') {
//           if (!manualMode) {
//             e.preventDefault()
//             agg.focus()
//           } else {
//             manualMode = false
//             e.preventDefault()
//             agg.focus()
//           }
//           return
//         }

//         // Programmatic focus → ignore
//       })

//       input.addEventListener('keydown', (e) => {
//         if (!manualMode && /^[0-9]$/.test(e.key)) {
//           manualMode = true
//         }

//         if (e.key === 'Backspace') {
//           if (input.value) {
//             input.value = ''
//             updateVerifyButtonState()
//           } else if (index > 0) {
//             otpInputs[index - 1].focus()
//             otpInputs[index - 1].value = ''
//           }
//           e.preventDefault()
//         }
//       })

//       input.addEventListener('input', (e) => {
//         if (!manualMode) return
//         const value = e.target.value.replace(/\D/g, '').slice(0, 1)
//         e.target.value = value
//         if (value && index < otpInputs.length - 1) {
//           otpInputs[index + 1].focus()
//         }
//         updateVerifyButtonState()
//       })

//       input.addEventListener('paste', (e) => {
//         e.preventDefault()
//         const pasted = (e.clipboardData || window.clipboardData)?.getData('text') || ''
//         manualMode = false // pasting = autofill
//         agg.value = pasted
//         fillFromCode(pasted)
//       })
//     })

//     phoneInput?.addEventListener('keydown', (e) => {
//       if (e.key === 'Enter') {
//         e.preventDefault()
//         if (!sendOtpButton?.disabled) sendOtpButton?.click()
//       }
//     })

//     function showStatus(message, isError = false) {
//       if (!statusMessageBox) return
//       statusMessageBox.textContent = message
//       statusMessageBox.className = 'status-message'
//       statusMessageBox.classList.add(isError ? 'error' : 'success')
//       statusMessageBox.style.display = 'block'
//       if (window.statusTimeout) clearTimeout(window.statusTimeout)
//       window.statusTimeout = setTimeout(() => {
//         statusMessageBox.style.display = 'none'
//       }, isError ? 5000 : 3000)
//     }

//     // --- Send OTP (keeps same UI transitions) ---
//     sendOtpButton?.addEventListener('click', async () => {
//       phoneNumber = formatPhoneNumber(phoneInput.value)
//       if (!isValidPhoneNumber(phoneInput.value)) {
//         showStatus('გთხოვთ შეიყვანოთ სწორი ტელეფონის ნომერი', true)
//         phoneInput.classList.add('invalid')
//         return
//       }
//       phoneInput.classList.remove('invalid')
//       sendOtpButton.disabled = true
//       try {
//         const response = await postJson(
//           'https://otp-auth.meama.ge/api/auth/send-otp',
//           { phoneNumber }
//         )
//         if (response.status === 429) throw new Error('ძალიან ბევრი მოთხოვნა. სცადეთ მოგვიანებით.')
//         const data = await response.json()
//         if (data.success) {
//           isOtpSent = true
//           if (phoneInput.parentElement) setDisplay(phoneInput.parentElement, 'none')
//           if (otpCont) setDisplay(otpCont, 'flex') // keep flex
//           showStatus('კოდი გამოგზავნილია', false)
//           if (sendOtpButton) setDisplay(sendOtpButton, 'none')
//           if (verifyOtpButton) {
//             setDisplay(verifyOtpButton, 'inline-flex') // keep inline-flex
//             verifyOtpButton.disabled = false // enabled initially when no digits entered
//           }
//         } else throw new Error(data.message || 'სერვერთან დაკავშირება ვერ მოხერხდა')
//       } catch (error) {
//         showStatus(error.message, true)
//         console.error('Error:', error)
//       } finally {
//         sendOtpButton.disabled = false
//       }
//     })

//     updateVerifyButtonState()

//     verifyOtpButton?.addEventListener('click', (e) => {
//       e.preventDefault() // stop native form submit that can reuse the previous session
//       const otp = Array.from(otpInputs).map((input) => input.value).join('')
//       // Don't verify if no digits are entered (button is lightened up but not functional)
//       if (!otp || otp.length === 0) return
//       verifyOtp(otp)
//     })
//   } catch (e) {
//     console.error('Error in login JS:', e)
//   }
// })



let phoneNumber = ''
let isOtpSent = false
let manualMode = false // false = aggregator/autofill mode, true = manual typing mode
let completedOnce = false // tracks if OTP was already filled once

document.addEventListener('DOMContentLoaded', () => {
  try {
    // --- setup ---
    // Cache DOM refs
    const loginTogglerButtons = document.querySelectorAll('.login_form_toggler_button')
    const togglerWrap = document.querySelector('.login_form_toggler')
    const sendOtpButton = document.getElementById('sendOtp')
    const verifyOtpButton = document.getElementById('verifyOtp')
    const isLoginPage = document.body.classList.contains('template-customers-login')

    const emailLoginCont = document.querySelector('.email_login_cont')
    const otpLoginCont = document.querySelector('.otp_login_cont')
    const emailRegisterCont = document.querySelector('.email_register_cont')
    const otpRegisterCont = document.querySelector('.otp_register_cont')

    const otpCont = document.querySelector('.otp_cont')
    const phoneInput = document.getElementById('CustomerPhone')
    const otpInputs = document.querySelectorAll('.otp_input')
    const otpInputContainer = document.querySelector('.otp_input_cont')
    const statusMessageParent = document.getElementById('statusMessageParent')
    const OTP_LENGTH = otpInputs.length

    // helpers that DO NOT change your show/hide logic
    const setDisplay = (el, v) => { if (el) el.style.display = v }
    const enableContainer = (container, isEnabled) => {
      if (!container) return
      container.querySelectorAll('input').forEach((input) => { input.disabled = !isEnabled })
    }

    // Network helper: try with credentials first, fall back to omit if browser blocks
    const postJson = async (url, payload, options = {}) => {
      const { withCredentials = true } = options
      const base = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
        cache: 'no-store',
        keepalive: true,
      }
      try {
        return await fetch(url, { ...base, credentials: withCredentials ? 'include' : 'omit' })
      } catch (err) {
        if (!withCredentials) throw err
        return fetch(url, { ...base, credentials: 'omit' })
      }
    }

    // --- Hidden aggregator (unchanged behavior) ---
    const agg = document.createElement('input')
    agg.type = 'tel'
    agg.inputMode = 'numeric'
    agg.autocomplete = 'one-time-code'
    agg.id = 'otp_agg'
    agg.setAttribute('aria-hidden', 'true')
    agg.tabIndex = -1
    Object.assign(agg.style, {
      position: 'absolute',
      left: '-9999px',
      top: '0',
      width: '1px',
      height: '1px',
      opacity: '0',
      pointerEvents: 'none'
    })
    if (otpInputContainer && otpInputContainer.parentElement) {
      otpInputContainer.parentElement.appendChild(agg)
    }

    // --- Centralized verifier (same API / flow) ---
    async function verifyOtp(otp) {
      if (!otp) {
        showStatus('გთხოვთ შეიყვანოთ კოდი', true)
        return
      }
      if (verifyOtpButton) verifyOtpButton.disabled = true
      try {
        const response = await postJson(
          'https://otp-auth.meama.ge/api/auth/verify-otp',
          { phoneNumber, otp }
        )
        const data = await response.json()
        if (data.success) {
          showStatus('წარმატებით შეხვედით', false)
          if (data.redirectUrl) window.location.href = data.redirectUrl
        } else {
          showStatus(data.message || 'არასწორი კოდი', true)
          if (data.redirectUrl) window.location.href = data.redirectUrl
          if (data.remainingAttempts) {
            showStatus(`დარჩენილი მცდელობების რაოდენობა: ${data.remainingAttempts}`, true)
          }
        }
      } catch (error) {
        showStatus('სერვერთან დაკავშირება ვერ მოხერხდა', true)
        console.error('Error:', error)
      } finally {
        if (verifyOtpButton) verifyOtpButton.disabled = false
      }
    }

function fillFromCode(code) {
  const digits = (code || '').replace(/\D/g, '').slice(0, OTP_LENGTH).split('');

  otpInputs.forEach((box, i) => { box.value = digits[i] || '' });

  updateVerifyButtonState();

  // If full OTP pasted/autofilled
  if (digits.length === OTP_LENGTH) {
    completedOnce = true;

    // LOCK USER INPUT & DISABLE BUTTON for the full 3.5s
    manualMode = false;  // block typing
    if (verifyOtpButton) verifyOtpButton.disabled = true;

    // Add a visual disabled state (optional)
    verifyOtpButton?.classList.add('locked');

    // unlock AFTER the timeout + automatically verify
    setTimeout(() => {
      verifyOtpButton?.classList.remove('locked');
      // still keep it disabled (your flow auto-verifies)
      verifyOtpButton.disabled = true;

      verifyOtp(digits.join(''));
    }, 3500);
  }
}

    // --- EXACT same toggler show/hide structure ---
    loginTogglerButtons.forEach((button, index) => {
      button.addEventListener('click', () => {
        loginTogglerButtons.forEach((btn) => btn.classList.remove('active'))

        if (index === 1) {
          togglerWrap && togglerWrap.classList.add('switched')
          if (isLoginPage) {
            setDisplay(emailLoginCont, 'flex')
            setDisplay(otpLoginCont, 'none')
            enableContainer(emailLoginCont, true)
            enableContainer(otpLoginCont, false)
          } else {
            setDisplay(emailRegisterCont, 'flex')
            setDisplay(otpRegisterCont, 'none')
            enableContainer(emailRegisterCont, true)
            enableContainer(otpRegisterCont, false)
          }
        } else {
          togglerWrap && togglerWrap.classList.remove('switched')
          if (isLoginPage) {
            setDisplay(emailLoginCont, 'none')
            setDisplay(otpLoginCont, 'flex')
            enableContainer(emailLoginCont, false)
            enableContainer(otpLoginCont, true)
          } else {
            setDisplay(emailRegisterCont, 'none')
            setDisplay(otpRegisterCont, 'grid') // IMPORTANT: keep grid
            enableContainer(emailRegisterCont, false)
            enableContainer(otpRegisterCont, true)
          }
        }
        button.classList.add('active')
      })
    })

    // --- Status box + styles (same visuals) ---
    const statusMessageBox = document.createElement('div')
    statusMessageBox.classList.add('status-message')
    if (statusMessageParent) statusMessageParent.insertAdjacentElement('afterend', statusMessageBox)

    if (otpCont) setDisplay(otpCont, 'none') // keep initial hidden

    const style = document.createElement('style')
    style.textContent = `
      #CustomerPhone.invalid { border-color: #f44336 !important; border-width: 2px !important; }
      #sendOtp, #verifyOtp { transition: opacity 0.3s ease, filter 0.3s ease; }
      /* keep disabled state lightly visible */
      #sendOtp:disabled, #verifyOtp:disabled { opacity: 0.88; filter: none; cursor: not-allowed; }
      /* explicit grey when lock state is applied */
      #verifyOtp.locked, #verifyOtp:disabled.locked { opacity: 0.5; filter: grayscale(0.85); }
      .status-message {
        padding: 10px; border-radius: 4px; margin-top: 10px;
        display: none; text-align: center; width: 100%;
        font-size: 14px; line-height: 1.4;
      }
      .status-message.error { background-color: #ffebee; color: #c62828; border: 1px solid #ef9a9a; }
      .status-message.success { background-color: #e8f5e9; color: #2e7d32; border: 1px solid #a5d6a7; }
    `
    document.head.appendChild(style)

    const ALLOWED_PHONE_CODES = [
      '995','49','33','39','34','1','44','48','90','994','374','7','380','375','998','992','996','86','81','82'
    ]
    const startsWithAllowedCode = (cleaned) => ALLOWED_PHONE_CODES.some((code) => cleaned.startsWith(code))
    const isGeorgianLocal = (number) => /^5\d{8}$/.test(number)
    const isValidPhoneNumber = (input) => {
      const cleaned = input.replace(/\D/g, '')
      if (isGeorgianLocal(cleaned)) return true
      return startsWithAllowedCode(cleaned) && cleaned.length >= 8
    }
    const formatPhoneNumber = (number) => {
      const cleaned = number.replace(/\D/g, '')
      if (isGeorgianLocal(cleaned)) return '995' + cleaned
      return cleaned
    }

    phoneInput?.addEventListener('input', (e) => {
      const isValid = isValidPhoneNumber(e.target.value)
      e.target.classList.toggle('invalid', !isValid)
    }, { passive: true })

    if (verifyOtpButton) verifyOtpButton.style.display = 'none'

    function updateVerifyButtonState() {
      const allFilled = Array.from(otpInputs).every((input) => input.value.length === 1)
      const anyFilled = Array.from(otpInputs).some((input) => input.value.length === 1)
      
      if (verifyOtpButton) {
        // In manual mode: enable button when all digits are filled
        // In autofill mode: disable button when any digit is entered (auto-verifies after 3.5s)
        if (manualMode) {
          verifyOtpButton.disabled = !allFilled
        } else {
          verifyOtpButton.disabled = anyFilled
        }
      }
    }

    // Restore OTP from storage
    const storedOtp = localStorage.getItem('lastOtp')
    if (storedOtp) {
      fillFromCode(storedOtp)
      localStorage.removeItem('lastOtp')
    }

    // Aggregator input
    agg.addEventListener('input', () => {
      if (manualMode) return // ignore autofill while in manual mode
      if (!agg.value) return
      fillFromCode(agg.value)
    })

    // Container paste
    otpInputContainer?.addEventListener('paste', (e) => {
      e.preventDefault()
      const text = (e.clipboardData || window.clipboardData)?.getData('text') || ''
      if (text) {
        manualMode = false
        agg.value = text
        fillFromCode(text)
      }
    })

    // --- Visible OTP boxes with pointer-based tap detection (unchanged) ---
    otpInputs.forEach((input, index) => {
      input.setAttribute('maxlength', '1')
      input.setAttribute('name', `otp_${index + 1}`)

      let lastTapTime = 0

      input.addEventListener('pointerdown', () => {
        const now = Date.now()
        const doubleTap = now - lastTapTime < 300
        lastTapTime = now
        input.dataset.tapType = doubleTap ? 'double' : 'single'
      })

      input.addEventListener('focus', (e) => {
        const tapType = input.dataset.tapType
        delete input.dataset.tapType

        if (tapType === 'double') {
          manualMode = true // sticky manual
          input.focus()
          input.select()
          return
        }

        if (tapType === 'single') {
          if (!manualMode) {
            e.preventDefault()
            agg.focus()
          } else {
            manualMode = false
            e.preventDefault()
            agg.focus()
          }
          return
        }

        // Programmatic focus → ignore
      })

      input.addEventListener('keydown', (e) => {
        if (!manualMode && /^[0-9]$/.test(e.key)) {
          manualMode = true
        }

        if (e.key === 'Backspace') {
          if (input.value) {
            input.value = ''
            updateVerifyButtonState()
          } else if (index > 0) {
            otpInputs[index - 1].focus()
            otpInputs[index - 1].value = ''
          }
          e.preventDefault()
        }
      })

      input.addEventListener('input', (e) => {
        if (!manualMode) return
        const value = e.target.value.replace(/\D/g, '').slice(0, 1)
        e.target.value = value
        if (value && index < otpInputs.length - 1) {
          otpInputs[index + 1].focus()
        }
        updateVerifyButtonState()
        
        // Auto-verify when all digits are manually entered
        const allFilled = Array.from(otpInputs).every((input) => input.value.length === 1)
        if (allFilled && manualMode) {
          const otp = Array.from(otpInputs).map((input) => input.value).join('')
          // Small delay to ensure UI updates
          setTimeout(() => {
            verifyOtp(otp)
          }, 100)
        }
      })

      input.addEventListener('paste', (e) => {
        e.preventDefault()
        const pasted = (e.clipboardData || window.clipboardData)?.getData('text') || ''
        manualMode = false // pasting = autofill
        agg.value = pasted
        fillFromCode(pasted)
      })
    })

    phoneInput?.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault()
        if (!sendOtpButton?.disabled) sendOtpButton?.click()
      }
    })

    function showStatus(message, isError = false) {
      if (!statusMessageBox) return
      statusMessageBox.textContent = message
      statusMessageBox.className = 'status-message'
      statusMessageBox.classList.add(isError ? 'error' : 'success')
      statusMessageBox.style.display = 'block'
      if (window.statusTimeout) clearTimeout(window.statusTimeout)
      window.statusTimeout = setTimeout(() => {
        statusMessageBox.style.display = 'none'
      }, isError ? 5000 : 3000)
    }

    // --- Send OTP (keeps same UI transitions) ---
    sendOtpButton?.addEventListener('click', async () => {
      phoneNumber = formatPhoneNumber(phoneInput.value)
      if (!isValidPhoneNumber(phoneInput.value)) {
        showStatus('გთხოვთ შეიყვანოთ სწორი ტელეფონის ნომერი', true)
        phoneInput.classList.add('invalid')
        return
      }
      phoneInput.classList.remove('invalid')
      sendOtpButton.disabled = true
      try {
        const response = await postJson(
          'https://otp-auth.meama.ge/api/auth/send-otp',
          { phoneNumber }
        )
        if (response.status === 429) throw new Error('ძალიან ბევრი მოთხოვნა. სცადეთ მოგვიანებით.')
        const data = await response.json()
        if (data.success) {
          isOtpSent = true
          if (phoneInput.parentElement) setDisplay(phoneInput.parentElement, 'none')
          if (otpCont) setDisplay(otpCont, 'flex') // keep flex
          showStatus('კოდი გამოგზავნილია', false)
          if (sendOtpButton) setDisplay(sendOtpButton, 'none')
          if (verifyOtpButton) {
            setDisplay(verifyOtpButton, 'inline-flex') // keep inline-flex
            verifyOtpButton.disabled = false // enabled initially when no digits entered
          }
        } else throw new Error(data.message || 'სერვერთან დაკავშირება ვერ მოხერხდა')
      } catch (error) {
        showStatus(error.message, true)
        console.error('Error:', error)
      } finally {
        sendOtpButton.disabled = false
      }
    })

    updateVerifyButtonState()

    verifyOtpButton?.addEventListener('click', (e) => {
      e.preventDefault() // stop native form submit that can reuse the previous session
      const otp = Array.from(otpInputs).map((input) => input.value).join('')
      // Don't verify if no digits are entered (button is lightened up but not functional)
      if (!otp || otp.length === 0) return
      verifyOtp(otp)
    })
  } catch (e) {
    console.error('Error in login JS:', e)
  }
})
